/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { RewardsDistribution } from "./RewardsDistribution";

export class RewardsDistributionFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<RewardsDistribution> {
    return super.deploy(overrides || {}) as Promise<RewardsDistribution>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): RewardsDistribution {
    return super.attach(address) as RewardsDistribution;
  }
  connect(signer: Signer): RewardsDistributionFactory {
    return super.connect(signer) as RewardsDistributionFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RewardsDistribution {
    return new Contract(address, _abi, signerOrProvider) as RewardsDistribution;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "RewardDistributed",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_destination",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "addRewardsDistribution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_perpToken",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "distributeRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "distributions",
    outputs: [
      {
        internalType: "address",
        name: "destination",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "amount",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_destination",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "editRewardsDistribution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardsController",
        type: "address",
      },
      {
        internalType: "contract IRewardRecipient",
        name: "_defaultRecipient",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256",
      },
    ],
    name: "removeRewardsDistribution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50611a31806100206000396000f3fe608060405234801561001057600080fd5b50600436106100a95760003560e01c80636c8381f8116100715780636c8381f814610126578063715018a61461013b5780638da5cb5b14610143578063bb69b0931461014b578063bc5920ba1461015e578063d34d4c3614610166576100a9565b806304770914146100ae57806313af4035146100c35780634487d3df146100d6578063485cc955146101005780634e0888ce14610113575b600080fd5b6100c16100bc3660046114a8565b610179565b005b6100c16100d13660046113cf565b61025c565b6100e96100e4366004611478565b610335565b6040516100f7929190611516565b60405180910390f35b6100c161010e3660046113eb565b610375565b6100c1610121366004611423565b610432565b61012e610552565b6040516100f79190611502565b6100c1610561565b61012e6105e0565b6100c1610159366004611478565b6105ef565b6100c1610708565b6100c1610174366004611423565b6107cb565b610181610b29565b6065546001600160a01b039081169116146101b75760405162461bcd60e51b81526004016101ae906118d8565b60405180910390fd5b61010054158015906101d0575061010054600019018311155b6101ec5760405162461bcd60e51b81526004016101ae90611925565b8161010084815481106101fb57fe5b906000526020600020906002020160000160006101000a8154816001600160a01b0302191690836001600160a01b0316021790555080610100848154811061023f57fe5b600091825260209091209151600160029092029092010155505050565b610264610b29565b6065546001600160a01b039081169116146102915760405162461bcd60e51b81526004016101ae906118d8565b6001600160a01b0381166102b75760405162461bcd60e51b81526004016101ae90611787565b6065546001600160a01b03828116911614156102e55760405162461bcd60e51b81526004016101ae90611952565b6066546001600160a01b03828116911614156103135760405162461bcd60e51b81526004016101ae9061164e565b606680546001600160a01b0319166001600160a01b0392909216919091179055565b610100818154811061034357fe5b6000918252602091829020600290910201805460408051938401905260019091015482526001600160a01b0316915082565b600054610100900460ff168061038e575061038e610b2d565b8061039c575060005460ff16155b6103b85760405162461bcd60e51b81526004016101ae906117c9565b600054610100900460ff161580156103e3576000805460ff1961ff0019909116610100171660011790555b6103eb610b33565b60fe80546001600160a01b038086166001600160a01b03199283161790925560ff805492851692909116919091179055801561042d576000805461ff00191690555b505050565b61043a610b29565b6065546001600160a01b039081169116146104675760405162461bcd60e51b81526004016101ae906118d8565b6001600160a01b03821661048d5760405162461bcd60e51b81526004016101ae90611617565b61049681610bc6565b6104b25760405162461bcd60e51b81526004016101ae90611817565b6104ba611357565b50604080518082019091526001600160a01b03928316815260208101918252610100805460018101825560009190915290517f45e010b9ae401e2eb71529478da8bd513a9bdc2d095a111e324f5b95c09ed87b600290920291820180546001600160a01b031916919094161790925551517f45e010b9ae401e2eb71529478da8bd513a9bdc2d095a111e324f5b95c09ed87c90910155565b6066546001600160a01b031690565b610569610b29565b6065546001600160a01b039081169116146105965760405162461bcd60e51b81526004016101ae906118d8565b6065546040516000916001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3606580546001600160a01b0319169055565b6065546001600160a01b031690565b6105f7610b29565b6065546001600160a01b039081169116146106245760405162461bcd60e51b81526004016101ae906118d8565b610100541580159061063d575061010054600019018111155b6106595760405162461bcd60e51b81526004016101ae90611925565b61010054600019018110156106d0576101008054600019810190811061067b57fe5b9060005260206000209060020201610100828154811061069757fe5b60009182526020909120825460029092020180546001600160a01b0319166001600160a01b039092169190911781556001918201549101555b6101008054806106dc57fe5b60008281526020812060026000199093019283020180546001600160a01b031916815560010155905550565b6066546001600160a01b03166107305760405162461bcd60e51b81526004016101ae90611889565b610738610b29565b6066546001600160a01b039081169116146107655760405162461bcd60e51b81526004016101ae90611695565b6066546065546040516001600160a01b0392831692909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a360668054606580546001600160a01b03199081166001600160a01b03841617909155169055565b60fe546001600160a01b03166107df610b29565b6001600160a01b0316146108055760405162461bcd60e51b81526004016101ae9061157c565b61080e81610bc6565b61082061081b8430610bca565b610bc6565b101561083e5760405162461bcd60e51b81526004016101ae9061171d565b61084661137f565b508060005b61010054811015610a5e5760006001600160a01b0316610100828154811061086f57fe5b60009182526020909120600290910201546001600160a01b0316148015906108cb57506108c861010082815481106108a357fe5b6000918252602091829020604080519384019052600160029092020101548152610bc6565b15155b15610a565761090e61010082815481106108e157fe5b6000918252602091829020604080519384019052600160029092020101548152839063ffffffff610c6016565b915061097384610100838154811061092257fe5b600091825260209091206002909102015461010080546001600160a01b03909216918590811061094e57fe5b6000918252602091829020604080519384019052600160029092020101548152610c8c565b6060610100828154811061098357fe5b90600052602060002090600202016001016040516024016109a491906119a2565b60408051601f198184030181529190526020810180516001600160e01b0316633c6b16ab60e01b1790526101008054919250600091849081106109e357fe5b60009182526020909120600290910201546040516001600160a01b0390911690610a0e9084906114e6565b6000604051808303816000865af19150503d8060008114610a4b576040519150601f19603f3d011682016040523d82523d6000602084013e610a50565b606091505b50505050505b60010161084b565b5060ff54610a779084906001600160a01b031683610c8c565b60ff54604051600162a6079360e01b031981526001600160a01b039091169063ff59f86d90610aaa908490600401611998565b600060405180830381600087803b158015610ac457600080fd5b505af1158015610ad8573d6000803e3d6000fd5b505050507feaf3d57629d9b1ce95715ccd98d6f5bf48023be1d5a06e09f64ab7f6d8be01d5610b0683610bc6565b610b0e610dbb565b604051610b1c9291906119ac565b60405180910390a1505050565b3390565b303b1590565b600054610100900460ff1680610b4c5750610b4c610b2d565b80610b5a575060005460ff16155b610b765760405162461bcd60e51b81526004016101ae906117c9565b600054610100900460ff16158015610ba1576000805460ff1961ff0019909116610100171660011790555b610ba9610dbf565b610bb1610e40565b8015610bc3576000805461ff00191690555b50565b5190565b610bd261137f565b610c5783846001600160a01b03166370a08231856040518263ffffffff1660e01b8152600401610c029190611502565b60206040518083038186803b158015610c1a57600080fd5b505afa158015610c2e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c529190611490565b610f1a565b90505b92915050565b610c6861137f565b610c7061137f565b82518451610c839163ffffffff610fac16565b81529392505050565b610c9583610fee565b610c9d61137f565b610ca78484610bca565b90506000610cb5858461103b565b905060006060866001600160a01b031663a9059cbb60e01b8785604051602401610ce0929190611530565b60408051601f198184030181529181526020820180516001600160e01b03166001600160e01b0319909416939093179092529051610d1e91906114e6565b6000604051808303816000865af19150503d8060008114610d5b576040519150601f19603f3d011682016040523d82523d6000602084013e610d60565b606091505b5091509150818015610d8a575080511580610d8a575080806020019051810190610d8a9190611458565b610da65760405162461bcd60e51b81526004016101ae906115a9565b610db2878785876110b9565b50505050505050565b4290565b600054610100900460ff1680610dd85750610dd8610b2d565b80610de6575060005460ff16155b610e025760405162461bcd60e51b81526004016101ae906117c9565b600054610100900460ff16158015610bb1576000805460ff1961ff0019909116610100171660011790558015610bc3576000805461ff001916905550565b600054610100900460ff1680610e595750610e59610b2d565b80610e67575060005460ff16155b610e835760405162461bcd60e51b81526004016101ae906117c9565b600054610100900460ff16158015610eae576000805460ff1961ff0019909116610100171660011790555b6000610eb8610b29565b606580546001600160a01b0319166001600160a01b038316908117909155604051919250906000907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a3508015610bc3576000805461ff001916905550565b610f2261137f565b6000610f2d84611112565b905060128110610f7257604080516020810190915280610f67610f5784601263ffffffff610fac16565b8690600a0a63ffffffff6111ff16565b815250915050610c5a565b604080516020810190915280610fa2610f9260128563ffffffff610fac16565b8690600a0a63ffffffff61124116565b9052949350505050565b6000610c5783836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f77000081525061127b565b6000610ff982611112565b6001600160a01b038316600090815260cb60205260409020549091508114611037576001600160a01b038216600090815260cb602052604090208190555b5050565b60008061104784611112565b9050601281106110855761107d61106582601263ffffffff610fac16565b600a0a61107185610bc6565b9063ffffffff61124116565b915050610c5a565b6110b161109960128363ffffffff610fac16565b600a0a6110a585610bc6565b9063ffffffff6111ff16565b949350505050565b6110ec6110d66110c98685610f1a565b839063ffffffff6112a716565b6110e08686610bca565b9063ffffffff6112ca16565b60000b1561110c5760405162461bcd60e51b81526004016101ae90611847565b50505050565b6001600160a01b038116600090815260cb602052604081205480610c5a5760408051600481526024810182526020810180516001600160e01b031663313ce56760e01b17905290516000916060916001600160a01b03871691611174916114e6565b600060405180830381855afa9150503d80600081146111af576040519150601f19603f3d011682016040523d82523d6000602084013e6111b4565b606091505b50915091508180156111c65750805115155b6111e25760405162461bcd60e51b81526004016101ae906116dc565b808060200190518101906111f69190611490565b95945050505050565b6000610c5783836040518060400160405280601a81526020017f536166654d6174683a206469766973696f6e206279207a65726f0000000000008152506112fb565b60008261125057506000610c5a565b8282028284828161125d57fe5b0414610c575760405162461bcd60e51b81526004016101ae90611746565b6000818484111561129f5760405162461bcd60e51b81526004016101ae9190611549565b505050900390565b6112af61137f565b6112b761137f565b82518451610c839163ffffffff61133216565b8051825160009110156112df57506001610c5a565b8151835110156112f25750600019610c5a565b50600092915050565b6000818361131c5760405162461bcd60e51b81526004016101ae9190611549565b50600083858161132857fe5b0495945050505050565b600082820183811015610c575760405162461bcd60e51b81526004016101ae906115e0565b604051806040016040528060006001600160a01b0316815260200161137a61137f565b905290565b6040518060200160405280600081525090565b6000602082840312156113a3578081fd5b6040516020810181811067ffffffffffffffff821117156113c2578283fd5b6040529135825250919050565b6000602082840312156113e0578081fd5b8135610c57816119e6565b600080604083850312156113fd578081fd5b8235611408816119e6565b91506020830135611418816119e6565b809150509250929050565b60008060408385031215611435578182fd5b8235611440816119e6565b915061144f8460208501611392565b90509250929050565b600060208284031215611469578081fd5b81518015158114610c57578182fd5b600060208284031215611489578081fd5b5035919050565b6000602082840312156114a1578081fd5b5051919050565b6000806000606084860312156114bc578081fd5b8335925060208401356114ce816119e6565b91506114dd8560408601611392565b90509250925092565b600082516114f88184602087016119ba565b9190910192915050565b6001600160a01b0391909116815260200190565b6001600160a01b0392909216825251602082015260400190565b6001600160a01b03929092168252602082015260400190565b60006020825282518060208401526115688160408501602087016119ba565b601f01601f19169190910160400192915050565b60208082526013908201527210afb932bbb0b93239a1b7b73a3937b63632b960691b604082015260600190565b6020808252601d908201527f446563696d616c45524332303a207472616e73666572206661696c6564000000604082015260600190565b6020808252601b908201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604082015260600190565b60208082526017908201527f43616e74206164642061207a65726f2061646472657373000000000000000000604082015260600190565b60208082526027908201527f5065727046694f776e61626c65557067726164653a2073616d652061732063616040820152666e64696461746560c81b606082015260800190565b60208082526027908201527f5065727046694f776e61626c65557067726164653a206e6f7420746865206e656040820152663b9037bbb732b960c91b606082015260800190565b60208082526021908201527f446563696d616c45524332303a2067657420646563696d616c73206661696c656040820152601960fa1b606082015260800190565b6020808252600f908201526e06e6f7420656e6f756768205045525608c1b604082015260600190565b60208082526021908201527f536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f6040820152607760f81b606082015260800190565b60208082526022908201527f5065727046694f776e61626c65557067726164653a207a65726f206164647265604082015261737360f01b606082015260800190565b6020808252602e908201527f436f6e747261637420696e7374616e63652068617320616c726561647920626560408201526d195b881a5b9a5d1a585b1a5e995960921b606082015260800190565b60208082526016908201527510d85b9d081859190818481e995c9bc8185b5bdd5b9d60521b604082015260600190565b60208082526022908201527f446563696d616c45524332303a2062616c616e636520696e636f6e73697374656040820152611b9d60f21b606082015260800190565b6020808252602f908201527f5065727046694f776e61626c65557067726164653a2063616e6469646174652060408201526e6973207a65726f206164647265737360881b606082015260800190565b6020808252602d908201527f5065727046694f776e61626c65557067726164653a2063616c6c65722069732060408201526c3737ba103a34329037bbb732b960991b606082015260800190565b602080825260139082015272696e646578206f7574206f6620626f756e647360681b604082015260600190565b60208082526026908201527f5065727046694f776e61626c65557067726164653a2073616d65206173206f726040820152651a59da5b985b60d21b606082015260800190565b9051815260200190565b9054815260200190565b918252602082015260400190565b60005b838110156119d55781810151838201526020016119bd565b8381111561110c5750506000910152565b6001600160a01b0381168114610bc357600080fdfea26469706673582212207d3d317a8e7bd1a337e45e63098f0b8516d987aff8e9a2932956fa400246db0f64736f6c63430006090033";
